import './DesktopViewport.scss';

import React from 'react';
import {Trip} from '../../react-app-env';
import Sidebar from '../sidebar/Sidebar';
import MapView from '../map/mapview/MapView';
import metaDataService from '../../services/MetaDataService';

export interface DesktopViewportProps {
  trip: Trip;
  googleMapsApiKey: string;
}

const DesktopViewport: React.FC<DesktopViewportProps> = ({ trip, googleMapsApiKey }) => {
  return (
      <main className='fr-desktop'>
        <Sidebar trip={trip}/>
        <MapView trip={trip}
                 googleMapsApiKey={googleMapsApiKey}
                 onGoogleMapsApiLoaded={(api) => {
                   metaDataService.setGoogleMapsApi(api);
                 }}/>
      </main>
  );
}

export default DesktopViewport;
